import { FC, useMemo, useState } from 'react';

import { useRecoilValue } from 'recoil';

import { useShopOrderListForWorkerHook } from '@shared/api/shopOrder/shopOrder.hook';
import { shopOrderListForWorkerSelector } from '@shared/api/shopOrder/shopOrder.selector';
import { Loading } from '@shared/components/Loading';
import { useAuth } from '@shared/state/hooks/useAuth';

import { AgencyWorkerAnnualAccountedTable } from '../containers/AgencyWorkerAccount/AgencyWorkerAnnualAccountTable';
import { NeedAccountTable } from '../containers/AgencyWorkerAccount/AgencyWorkerNeedAccountTable';
import { useTitleHook } from '../hooks/useTitleHook';

const WorkerAccouintPointPage: FC = function WorkerAccouintPointPage() {
  useTitleHook('정산금 내역');

  const { userProfile, userBugoBrand } = useAuth();

  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState<number>(currentYear);

  // 연도 선택 옵션 생성 (현재 연도부터 5년 전까지)
  const yearOptions = useMemo(() => {
    const years: number[] = [];
    for (let i = 0; i < 5; i++) {
      years.push(currentYear - i);
    }
    return years;
  }, [currentYear]);

  useShopOrderListForWorkerHook(selectedYear);

  const shopOrderListState = useRecoilValue(shopOrderListForWorkerSelector);

  const accountTable = useMemo(() => {
    if (shopOrderListState.status === 'success' && shopOrderListState.data) {
      const shopOrderList = shopOrderListState.data;

      const needShopOrderList = shopOrderList.filter((order) => {
        return !order.paymentDetail.isRebated;
      });

      return (
        <div>
          <NeedAccountTable shopOrderList={needShopOrderList} />
        </div>
      );
    }
  }, [shopOrderListState.data, shopOrderListState.status]);

  const accountedTable = useMemo(() => {
    if (shopOrderListState.status === 'success' && shopOrderListState.data) {
      const shopOrderList = shopOrderListState.data;

      return (
        <div>
          <AgencyWorkerAnnualAccountedTable
            shopOrderList={shopOrderList}
            selectedYear={selectedYear}
          />
        </div>
      );
    }
  }, [shopOrderListState.data, shopOrderListState.status, selectedYear]);

  if (userBugoBrand) {
    // eslint-disable-next-line no-constant-condition
    if (userBugoBrand?.bugoAgency?.shareRebateWithWorker || true) {
      return (
        <div className="space-y-3 py-3 text-sm">
          {/* 환영합니다~~~ */}
          <div className="center-box py-2 theme-bg-1">
            <p className="center-box text-base font-medium">
              <strong className="theme-text-main">{userProfile?.info.name}</strong>님
              환영합니다
            </p>
          </div>
          {/* 정산 예정내역 */}
          <div className="py-4 px-4 theme-bg-1">{accountTable}</div>
          {/* 연도 선택 및 연간 정산 내역 */}
          <div className="py-4 px-4 theme-bg-1">
            <div className="mb-3 flex items-center justify-between">
              <span className="font-medium">연간 정산 내역</span>
              <select
                value={selectedYear}
                onChange={(e) => setSelectedYear(Number(e.target.value))}
                className="rounded border border-gray-300 px-3 py-1.5 text-sm focus:border-blue-500 focus:outline-none"
              >
                {yearOptions.map((year) => (
                  <option key={year} value={year}>
                    {year}년
                  </option>
                ))}
              </select>
            </div>
            {accountedTable}
          </div>
        </div>
      );
    } else {
      //
      // return <Navigate to="/"></Navigate>;
    }
  } else {
    return (
      <div className="center-box h-screen-15">
        <Loading></Loading>
      </div>
    );
  }
};

export default WorkerAccouintPointPage;
